import {ImageCTACard, ImageCTACardProps} from 'src/component/partial/ImageCTACard';

import {useViewportSize} from '#hook';

export const SurveyCTACard = (props: ImageCTACardProps) => {
  const {isDesktop, isTablet} = useViewportSize();
  const lifestyleSurveyImageUrl = isDesktop
    ? '/image/action-plan/take-a-lifestyle-survey.jpg'
    : '/image/action-plan/take-a-lifestyle-survey-mobile.jpg';
  let lifestyleSurveyImagePosition: string;

  if (isDesktop) {
    lifestyleSurveyImagePosition = 'center';
  } else if (isTablet) {
    lifestyleSurveyImagePosition = '0 15%';
  } else {
    lifestyleSurveyImagePosition = 'top';
  }

  return (
    <ImageCTACard
      headline="Get your Lifestyle Score"
      href="/survey"
      imageUrl={lifestyleSurveyImageUrl}
      objectPosition={lifestyleSurveyImagePosition}
      lede="Take our Lifestyle Survey to see how you’re doing across five main health categories."
      {...props}
    />
  );
};
